import { factory } from '@opten/compiler/factory';
import '../../Opten.HypothekarbankLenzburg.Core.Static/utilities/polyfills';
import './hblasset.scss';

import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef } from '@opten/compiler/metadata/di';

import filterpage, {
	FilterPage
} from '../../Opten.HypothekarbankLenzburg.Core.Static/components/filterpage';

import cookieConsent from '../../Opten.HypothekarbankLenzburg.Core.Static/components/cookie-consent';
import Datepicker from '../../Opten.HypothekarbankLenzburg.Core.Static/components/datepicker';
import InputFieldsFilled from '../../Opten.HypothekarbankLenzburg.Core.Static/components/input-fields-filled';
import { Player } from '../../Opten.HypothekarbankLenzburg.Core.Static/components/player/player';

import Dialog from '../../Opten.HypothekarbankLenzburg.Core.Static/components/dialog/dialog';
import recaptchaValidator from '../../Opten.HypothekarbankLenzburg.Core.Static/components/recaptcha';
import recaptcha3Validator from '../../Opten.HypothekarbankLenzburg.Core.Static/components/recaptcha-3';
import { SelectComponent } from '../../Opten.HypothekarbankLenzburg.Core.Static/components/select/select';

import { Navbar, NavbarMegaDropdown, NavbarToggler } from './components/navbar';
import { SliderComponent } from './components/slider';

import { Search, SearchDesktop, SearchToggler } from './components/search';

import { Header } from './components/header/header';
import { MapExtendedComponent } from './components/map-extended';

import { BackToTopComponent } from './components/back-to-top/back-to-top';

import { NavigationHideScrollDownShowScrollUpComponent } from './components/back-to-top/navigation';

@Component({ className: 'js-recaptcha', observe: true })
class RecaptchaValidator {
	constructor(private element: HTMLElement) {
		recaptchaValidator(element);
	}
}

@Component({ className: 'js-recaptcha-3', observe: true })
class Recaptcha3Validator {
	constructor(private element: HTMLInputElement) {
		recaptcha3Validator(element);
	}
}

@Component({ className: 'js-cookie-consent' })
class CookieConsent {
	constructor(private element: HTMLElement) {
		/*const header = document.getElementsByClassName(
			'js-header'
		)[0] as HTMLElement;*/
		const connectionIsSecure = element.hasAttribute('data-cookie-secure')
			? element.getAttribute('data-cookie-secure').toLowerCase() ===
			  'true'
			: true;
		cookieConsent([], {
			showAfter: 600,
			cookie: {
				expirationInDays: 365,
				secure: connectionIsSecure
			}
		});
	}
}

@Component({ className: 'js-form__field-accept', observe: true })
class FormFieldAccept {
	constructor(private element: HTMLElement) {
		if (element.hasAttribute('data-id')) {
			element.addEventListener('click', () => {
				const id = element.getAttribute('data-id');
				const checkbox = document.querySelector<HTMLInputElement>(
					'[id="' + id + '"]'
				);

				if (checkbox) {
					checkbox.checked = true;
				}
			});
		}
	}
}

@Component({ className: 'js-filter__page' })
class FilterPageComponent {
	@ComponentRef(Header) _headerElement: Header;
	filterPage: FilterPage;

	constructor(private element: HTMLElement) {
		this.filterPage = filterpage(element, {
			loading: {
				contentLoading:
					'<div class="col-12 module"><div class="c-loading-indicator">Loading...</div></div>',
				contentYScroll: 0
			},
			callbackAfterFilter: () => {
				this._headerElement._update(0);
				this.filterPage.initContentFilter();
				this.filterPage.reinitFilter();
			}
		});
	}
}

factory([
	Player,
	CookieConsent,
	SelectComponent,
	Header,
	Search,
	SearchDesktop,
	Navbar,
	NavbarMegaDropdown,
	NavbarToggler,
	SearchToggler,
	NavigationHideScrollDownShowScrollUpComponent,
	BackToTopComponent,
	InputFieldsFilled,
	FormFieldAccept,
	SliderComponent,
	FilterPageComponent,
	RecaptchaValidator,
	Recaptcha3Validator,
	MapExtendedComponent,
	Dialog,
	Datepicker
])(document.body);
